import React from "react";
import { displayBalance } from "../../utils/Helpers";
import { HORIZON } from "../../../constants/horizon";

export const AccountPharmaciesTabRow = ({ pharmacy }) => {
  // ["1 dea", "2 hin", "5 npi"]
  const associatedIds = ["dea", "hin", "npi"].map((type) => {
    const count = pharmacy.identifier_associations.filter(
      (ia) => ia.identifier_type == type
    ).length;

    return `${displayBalance(count)} ${type}`;
  });

  return (
    <>
      <div
        className="row align-items-center bg--light-navy"
        style={{ minHeight: 48 }}
        key={pharmacy.name + pharmacy.address}
      >
        <div className="col">
          <div className="flex align-items-center py--12">
            <div>
              <div className="t--500 mb-1">{pharmacy.name}</div>
              <div className="t--secondary">{pharmacy.address}</div>
            </div>
          </div>
        </div>
        <div className="col">
          <div className="flex gap--8 align-items-center">
            {associatedIds.map((associatedId) => (
              <div
                className="badge border--none shadow-none bg--light-blue t--blue border--rounded"
                key={associatedId}
              >
                {associatedId}
              </div>
            ))}
          </div>
        </div>
      </div>

      {pharmacy.identifier_associations
        .sort(
          (a, b) =>
            HORIZON.IDENITIFER_SORT_ORDER.indexOf(a.identifier_type) -
            HORIZON.IDENITIFER_SORT_ORDER.indexOf(b.identifier_type)
        )
        .map((ia) => (
          <div
            key={ia.identifier + ia.identifier_type}
            className="row bg--white py-3 row-border-bottom"
          >
            <div className="col t--500">{ia.identifier}</div>
            <div className="col">{ia.identifier_type.toUpperCase()}</div>
          </div>
        ))}
    </>
  );
};
